import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'surveyForm',
    'surveyErrors',
    'primaryRadio',
    'submitButton',
    'textInput',
    'charCount',
  ];

  static MAX_CHAR_LENGTH = 200;

  select() {
    if (!this.validatePrimaryReason()) return;
    this.submitButtonTarget.removeAttribute('disabled');
  }

  validatePrimaryReason() {
    return this.primaryRadioTargets.some((checkbox) => checkbox.checked);
  }

  onPostSuccess(event) {
    const xhr = event.detail[2];

    this.surveyFormTarget.innerHTML = xhr.response;

    let inputField = document.getElementById(
      'attribution_survey_secondary_reason'
    );

    if (inputField) inputField.focus();

    let otherInputField = document.getElementById(
      'attribution_survey_tertiary_reason'
    );

    if (otherInputField) otherInputField.focus();

    // Focus on open text question input if present and initialize character count
    if (this.hasTextInputTarget) {
      this.textInputTarget.focus();
      // Initialize character count if present
      if (this.hasCharCountTarget) {
        const remaining =
          this.constructor.MAX_CHAR_LENGTH -
          (this.textInputTarget.value.length || 0);
        this.charCountTarget.textContent = remaining;
      }
    }

    // The following code will dismiss the survey modal when the user clicks on
    // either the secondary or teriary submit button
    const tertiaryRadioButtons = document.querySelectorAll(
      '.js-tertiary-check input[type="radio"]'
    );

    const tertiarySubmitButton = document.querySelector(
      '.js-tertiary-submit input[type="submit"]'
    );

    tertiaryRadioButtons.forEach(function (radioButton) {
      radioButton.addEventListener('click', function () {
        if (radioButton.checked) {
          if (
            radioButton.value === 'Someone I follow' ||
            radioButton.value === 'Other'
          ) {
            tertiarySubmitButton.removeAttribute('data-bs-dismiss');
          }
        }
      });
    });
  }

  onPostError() {}

  updateCharCount(event) {
    if (!this.hasCharCountTarget) return;
    const input = event.target;
    const remaining = this.constructor.MAX_CHAR_LENGTH - input.value.length;
    this.charCountTarget.textContent = remaining;
  }
}
